import React from 'react';
import { Link } from 'react-router-dom';
import './BillingError.css';

function BillingError() {
  return (
    <div className="billing-error-container">
      <div className="billing-error-card">
        <div className="billing-error-icon">⚠️</div>
        <h1>Billing Error</h1>
        <p>We encountered an issue while processing your billing request.</p>
        <p className="billing-error-subtext">
          This could be a temporary issue. Please try again, or contact support 
          if the problem persists.
        </p>
        <div className="billing-error-actions">
          <Link to="/pricing" className="billing-error-btn-primary">
            Try Again
          </Link>
          <Link to="/contact" className="billing-error-btn-secondary">
            Contact Support
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BillingError;
